var map = {
	"./NFHS4_district_maps/andaman & nicobar islands.json": [
		23340,
		3340
	],
	"./NFHS4_district_maps/andhra pradesh.json": [
		38693,
		8693
	],
	"./NFHS4_district_maps/arunachal pradesh.json": [
		56731,
		6731
	],
	"./NFHS4_district_maps/assam.json": [
		87770,
		7770
	],
	"./NFHS4_district_maps/bihar.json": [
		85664,
		5664
	],
	"./NFHS4_district_maps/chandigarh.json": [
		50983,
		983
	],
	"./NFHS4_district_maps/chhattisgarh.json": [
		58490,
		8490
	],
	"./NFHS4_district_maps/dadra & nagar haveli.json": [
		36504,
		6504
	],
	"./NFHS4_district_maps/daman & diu.json": [
		36960,
		6960
	],
	"./NFHS4_district_maps/goa.json": [
		60477,
		477
	],
	"./NFHS4_district_maps/gujarat.json": [
		75559,
		5559
	],
	"./NFHS4_district_maps/haryana.json": [
		33853,
		3853
	],
	"./NFHS4_district_maps/himachal pradesh.json": [
		78102,
		8102
	],
	"./NFHS4_district_maps/jammu & kashmir.json": [
		62212,
		2212
	],
	"./NFHS4_district_maps/jharkhand.json": [
		89784,
		9784
	],
	"./NFHS4_district_maps/karnataka.json": [
		30784,
		784
	],
	"./NFHS4_district_maps/kerala.json": [
		92104,
		2104
	],
	"./NFHS4_district_maps/lakshadweep.json": [
		82080,
		2080
	],
	"./NFHS4_district_maps/madhya pradesh.json": [
		71420,
		1420
	],
	"./NFHS4_district_maps/maharashtra.json": [
		65474,
		5474
	],
	"./NFHS4_district_maps/manipur.json": [
		11019,
		1019
	],
	"./NFHS4_district_maps/meghalaya.json": [
		93550,
		3550
	],
	"./NFHS4_district_maps/mizoram.json": [
		90397,
		397
	],
	"./NFHS4_district_maps/nagaland.json": [
		31702,
		1702
	],
	"./NFHS4_district_maps/nct of delhi.json": [
		56121,
		6121
	],
	"./NFHS4_district_maps/odisha.json": [
		28284,
		8284
	],
	"./NFHS4_district_maps/puducherry.json": [
		36356,
		6356
	],
	"./NFHS4_district_maps/punjab.json": [
		67629,
		7629
	],
	"./NFHS4_district_maps/rajasthan.json": [
		93801,
		3801
	],
	"./NFHS4_district_maps/sikkim.json": [
		88060,
		8060
	],
	"./NFHS4_district_maps/tamil nadu.json": [
		51045,
		1045
	],
	"./NFHS4_district_maps/telangana.json": [
		40998,
		998
	],
	"./NFHS4_district_maps/tripura.json": [
		41071,
		1071
	],
	"./NFHS4_district_maps/uttar pradesh.json": [
		69353,
		9353
	],
	"./NFHS4_district_maps/uttarakhand.json": [
		71540,
		1540
	],
	"./NFHS4_district_maps/west bengal.json": [
		67725,
		7725
	],
	"./NFHS5_district_maps/andaman & nicobar islands.json": [
		64066
	],
	"./NFHS5_district_maps/andhra pradesh.json": [
		46286
	],
	"./NFHS5_district_maps/arunachal pradesh.json": [
		15292
	],
	"./NFHS5_district_maps/assam.json": [
		5215
	],
	"./NFHS5_district_maps/bihar.json": [
		47373
	],
	"./NFHS5_district_maps/chandigarh.json": [
		87448
	],
	"./NFHS5_district_maps/chhattisgarh.json": [
		54037
	],
	"./NFHS5_district_maps/dadra & nagar haveli and daman & diu.json": [
		48502
	],
	"./NFHS5_district_maps/goa.json": [
		35609
	],
	"./NFHS5_district_maps/gujarat.json": [
		88680
	],
	"./NFHS5_district_maps/haryana.json": [
		7577
	],
	"./NFHS5_district_maps/himachal pradesh.json": [
		52277
	],
	"./NFHS5_district_maps/jammu & kashmir.json": [
		32405,
		2405
	],
	"./NFHS5_district_maps/jharkhand.json": [
		71400,
		1400
	],
	"./NFHS5_district_maps/karnataka.json": [
		61061,
		1061
	],
	"./NFHS5_district_maps/kerala.json": [
		20789,
		789
	],
	"./NFHS5_district_maps/ladakh.json": [
		14712,
		4712
	],
	"./NFHS5_district_maps/lakshadweep.json": [
		36378,
		6378
	],
	"./NFHS5_district_maps/madhya pradesh.json": [
		34269,
		7848
	],
	"./NFHS5_district_maps/maharashtra.json": [
		2982,
		2982
	],
	"./NFHS5_district_maps/manipur.json": [
		61784,
		1784
	],
	"./NFHS5_district_maps/meghalaya.json": [
		58162,
		8162
	],
	"./NFHS5_district_maps/mizoram.json": [
		6127,
		6127
	],
	"./NFHS5_district_maps/nagaland.json": [
		71686,
		1686
	],
	"./NFHS5_district_maps/nct delhi.json": [
		57914
	],
	"./NFHS5_district_maps/odisha.json": [
		31795,
		1795
	],
	"./NFHS5_district_maps/puducherry.json": [
		89845,
		9845
	],
	"./NFHS5_district_maps/punjab.json": [
		83833,
		3833
	],
	"./NFHS5_district_maps/rajasthan.json": [
		44886,
		4886
	],
	"./NFHS5_district_maps/sikkim.json": [
		5595,
		5595
	],
	"./NFHS5_district_maps/tamil nadu.json": [
		9028,
		9028
	],
	"./NFHS5_district_maps/telangana.json": [
		2869,
		2869
	],
	"./NFHS5_district_maps/tripura.json": [
		80445,
		445
	],
	"./NFHS5_district_maps/uttar pradesh.json": [
		3300,
		3300
	],
	"./NFHS5_district_maps/uttarakhand.json": [
		50778,
		778
	],
	"./NFHS5_district_maps/west bengal.json": [
		65843,
		5843
	],
	"./india-highcharts.json": [
		98258
	],
	"./india-states.json": [
		3403,
		3403
	],
	"./india.geo.json": [
		21450,
		1450
	],
	"./india.json": [
		89168,
		9168
	],
	"./india1.geo.json": [
		22305
	],
	"./india_district_old_v2.json": [
		68209
	],
	"./india_state_nfhs5.json": [
		1495
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 770;
module.exports = webpackAsyncContext;